import { useMemo } from "react";

import { useUserCurrency } from "@features/user/hooks/useUserCurrency";

export const ConfiguredCurrency = () => {
  const { currentCurrency, currentCurrencyCode } = useUserCurrency();

  const currencyText = useMemo(() => {
    if (currentCurrency) {
      return (
        <span>
          <span className="font-bold">{currentCurrency.pluralLabel}</span> (
          <span className="font-bold">{currentCurrency.value}</span>)
        </span>
      );
    }
    /* If the currency code is not in the mapping, an error should have been logged.  We will just
       display the raw value (which should be a currency code) as a fallback. */
    return (
      <span className="font-bold">{currentCurrencyCode.toUpperCase()}</span>
    );
  }, [currentCurrency, currentCurrencyCode]);

  return (
    <div className="flex flex-col gap-3 p-5 px-7 bg-white rounded-md border container-xl">
      <div className="flex flex-col gap-3">
        <h1 className="mx-0 mt-0 mb-0 heading">Currency</h1>
        <hr className="mt-0 mb-0" />
      </div>
      <div className="flex relative flex-col gap-2 grow">
        <div>
          Your dashboard is currently set to display data in {currencyText}.
        </div>
        <div>
          Changing your preferred currency requires reaching out to our team who
          will then recalculate all of your data - a process which may take up
          to 24 hours. During this period, data in your dashboard will not
          reflect the changed currency.
        </div>
        <div>
          Please reach out to{" "}
          <a
            className="text-cosmic hover:text-cosmic+1"
            href="mailto:success@northbeam.io"
            target="_blank"
            rel="noopener noreferrer"
          >
            success@northbeam.io
          </a>{" "}
          to request a change to the preferred currency in your dashboard.
        </div>
      </div>
    </div>
  );
};
